var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4658_564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48.5C37.2548 48.5 48 37.7548 48 24.5C48 11.2452 37.2548 0.5 24 0.5C10.7452 0.5 0 11.2452 0 24.5C0 37.7548 10.7452 48.5 24 48.5Z",
    fill: "#F14965"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9307 35.3265L26.877 48.2729C37.7792 46.9858 46.4102 38.4306 47.7729 27.5284L34.7509 14.5063L13.9307 35.3265Z",
    fill: "#AD0E29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3565 29.7998C36.4165 30.8597 36.4165 32.6767 35.3565 33.7367L33.2366 35.8565C32.1767 36.9165 30.3597 36.9165 29.2997 35.8565L12.6436 19.2004C11.5836 18.1405 11.5836 16.3234 12.6436 15.2635L14.8392 13.0679C15.8991 12.008 17.7161 12.008 18.7761 13.0679L35.3565 29.7998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5739 20.9417L20.4414 27.0741L29.2994 35.8565C30.3594 36.9164 32.1764 36.9164 33.2364 35.8565L35.4319 33.6609C36.4919 32.601 36.4919 30.7839 35.4319 29.724L26.5739 20.9417Z",
    fill: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2997 13.1436C30.3597 12.0836 32.1767 12.0836 33.2366 13.1436L35.4322 15.3392C36.4922 16.3991 36.4922 18.2161 35.4322 19.2761L18.7004 35.8565C17.6404 36.9165 15.8234 36.9165 14.7635 35.8565L12.6436 33.7366C11.5836 32.6767 11.5836 30.8597 12.6436 29.7997L29.2997 13.1436Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4658_564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.879af2f5a9de9b66373a708e2956f495.svg";
export { ForwardRef as ReactComponent };